<p-menu #menu [model]="items" [popup]="true" [styleClass]="'text-sm'"></p-menu>

@if (event) {
  <!-- edit event modal -->
  <app-edit-event (onEventSubmitted)="this.onEditSuccessEmitter.emit($event)"
    (onCancelModal)="showEditEventModal = false"
  [display]="showEditEventModal" [event]="event"></app-edit-event>
  <!-- edit event image modal -->
  <app-edit-event-image (onEventSubmitted)="this.onEventEditImageSuccess($event)"
    (onCancelModal)="showEditEventImageModal = false"
  [display]="showEditEventImageModal" [event]="event"></app-edit-event-image>
  <!-- display event modal -->
  <app-event-detail-info-modal (onCancelModal)="showEventDetailInfoModal = false"
  [display]="showEventDetailInfoModal" [event]="event"></app-event-detail-info-modal>
  <!-- display event treatment modal -->
  <app-event-treatment-modal
    (onEventTreatmentSuccess)="onEventTreatmentSuccess.emit(event.id)"
    (onCancelModal)="showTreatmentModal = false" [display]="showTreatmentModal"
  [event]="event"></app-event-treatment-modal>
  <!-- display event closure modal-->
  <app-event-closure-modal
    (onCloseSuccess)="this.onCloseSuccessEmitter.emit(this.event.id)"
    (onCancelModal)="showClosureModal = false" [display]="showClosureModal"
  [event]="event"></app-event-closure-modal>
  <app-event-remove-modal
    [isEventOwner]="isEventOwner()"
    (onCloseSuccess)="this.onRestoreToRemoveSuccess.emit($event)"
    (onCancelModal)="showRemoveModal = false" [display]="showRemoveModal"
  [event]="event"></app-event-remove-modal>
  <app-event-remove-reason-modal
    (onCloseSuccess)="this.onRestoreToRemoveSuccess.emit($event)"
    (onCancelModal)="showPreRemoveReasonModal = false" [display]="showPreRemoveReasonModal && isAdmin"
  [event]="event"></app-event-remove-reason-modal>
  <!-- report modal -->
  <app-report-modal (onCancelModal)="showReportModal = false" [display]="showReportModal" [event]="event">
  </app-report-modal>
}
